exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "leaderboard-settings .mat-input-element {\n  text-align: center;\n  font-weight: bold; }\n\nleaderboard-settings .mat-typography h3, leaderboard-settings .mat-typography h4 {\n  margin-bottom: 0px; }\n\nleaderboard-settings .mat-select {\n  padding-top: 0px; }\n\nleaderboard-settings .settings-line {\n  max-height: 50px !important;\n  min-height: 50px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/leaderboard-settings/leaderboard-settings.component.scss
// module id = ../../../../../src/app/component-module/leaderboard-settings/leaderboard-settings.component.scss
// module chunks = main